export default __webpack_public_path__ + "static/media/IMG_1995.8c03463d.JPG";